import { COWORKING } from '@/types/spaceTypes.constants';

export const getFormattedPriceObject = (spaceInfo, currencyType) => {
  if (!spaceInfo) return '';

  const basePrice =
    spaceInfo?.subtype_id === COWORKING ? spaceInfo?.rate_24_hours : spaceInfo?.hourly_rate;

  const convertedPrice =
    spaceInfo?.subtype_id === COWORKING
      ? spaceInfo?.rate_24_hours_converted
      : spaceInfo?.hourly_rate_converted;

  let transformPrice;

  if (currencyType === 'MXN') {
    transformPrice = spaceInfo?.currency === 'MXN' ? basePrice : convertedPrice;
  } else if (currencyType === 'USD') {
    transformPrice = spaceInfo?.currency === 'USD' ? basePrice : convertedPrice;
  }

  const calculatedPrice = Math.round(parseFloat(transformPrice));
  const currency = currencyType === 'USD' ? 'USD' : 'MXN';

  return {
    calculatedPrice,
    currency,
    formattedPrice: `${calculatedPrice} ${currency}`,
  };
};

export const getFormattedPriceObjectASD = (spaceInfo, currencyType, convert, convertBack) => {
  if (!spaceInfo) return '';
  const usdIds = [154, 155, 156, 157, 158, 159, 160, 161, 162];
  const price =
    spaceInfo?.subtype_id === COWORKING ? spaceInfo?.rate_24_hours : spaceInfo?.hourly_rate;

  let transformPrice;
  if (currencyType === 'MXN') {
    transformPrice = usdIds?.includes(Number(spaceInfo?.space_id)) ? convertBack(price) : price;
  } else if (currencyType === 'USD') {
    transformPrice = usdIds?.includes(Number(spaceInfo?.space_id)) ? price : convert(price);
  }

  const calculatedPrice = Math.round(parseFloat(transformPrice));
  const currency = currencyType === 'USD' ? 'USD' : 'MXN';

  console.log(`[getFormattedPriceObject] space_id=${spaceInfo.space_id}`, {
    subtype: spaceInfo.subtype_id,
    inputPrice: price,
    outputPrice: calculatedPrice,
    currency,
  });

  return {
    calculatedPrice: calculatedPrice,
    currency: currency,
    formattedPrice: `${calculatedPrice} ${currency}`,
  };
};
